<script setup>
import '@/assets/cloudCounter/css/style.css'
import { ref, defineProps, } from 'vue';
import Layout from '@/components/cloudCounter/Layout.vue'
import CaseBox from '@/components/cloudCounter/CaseBox.vue'

const download = () => {

}

</script>

<template>

    <Layout class="bg-white" :header="{ text: '', backBtn: { visible: false }, closeBtn: { visible: true, to: {} }, }">

        <div class="pt-2 pb-10">
            <div class="pb-4 text-center">
                <div class="inline-block">
                    <svg width="73" height="72" viewBox="0 0 73 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_755_21211)">
                            <rect x="21.3271" y="52.1768" width="56.6171" height="10"
                                transform="rotate(-45 21.3271 52.1768)" fill="#70E1F2" />
                            <rect width="30" height="10"
                                transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 35.4688 52.1768)"
                                fill="#70F2D0" />
                            <rect width="10" height="10"
                                transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 35.4688 52.1768)"
                                fill="#11699C" />
                        </g>
                        <defs>
                            <clipPath id="clip0_755_21211">
                                <rect width="72" height="72" fill="white" transform="translate(0.5)" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <h2 class="font-bold text-2xl">委託受理完成</h2>
            </div>
            <div class="text-sm">
                <p class="pb-2">
                    本次申請金額預計 1 個小時內可匯入您的帳戶，惟仍可能因以下情形而有調整：
                </p>
                <ol class="list-decimal pl-5">
                    <li>您的帳戶資訊有誤或因戶名難字或其他原因致銀行無法接收。</li>
                    <li>申請交易時間已逾當日匯款時間，則於次一營業日匯款。</li>
                </ol>
            </div>
        </div>

        <div class="pb-6">
            <div class="flex items-end pb-4">
                <h3 class="flex-1 font-bold text-xl">申請紀錄</h3>
                <button class="pt-3 text-sm text-[#0093C1]" @click="download">
                    <svg class="inline-block" width="16" height="16" viewBox="0 0 16 16" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M2.66699 8V11.3333C2.66699 12.0697 3.26395 12.6667 4.00033 12.6667H7.01088H12.0003C12.7367 12.6667 13.3337 12.0697 13.3337 11.3333V8"
                            stroke="#0093C1" stroke-width="1.3" stroke-linecap="round" />
                        <path d="M5.33301 6.66667L7.99967 9.58203M7.99967 9.58203L10.6663 6.66667M7.99967 9.58203V2"
                            stroke="#0093C1" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    下載
                </button>
            </div>

            <CaseBox :hasShadow="false" :caseBox="{
        boxList: [
            {
                flexClass: 'justify-between',
                list: [
                    { key: '申請項目', value: '保單借款' },
                    { key: '申請日期', value: '113/04/08' },
                    { key: '受理案號', value: '114-WBP-0023902' }
                ]
            }
        ]
    }"></CaseBox>
        </div>

        <ul class="list-disc pl-6 text-sm">
            <li class="pb-2">本次受理案號申請內容為加密之PDF檔，密碼為您登入時之要保人身分證字號(大小寫視為不同字母) 。</li>
            <li class="pb-2">若辦理保單借款時，保單尚有未清償之借款本息者，本次欲借款金額加前次借款本息合計需於保單最高可借範圍內。</li>
            <li class="pb-2">保險單借款作業完成後，本公司會將「保險單借款給付通知」以E-MAIL方式傳送給您。</li>
            <li class="pb-2">請妥善保存「保險單借款給付通知」，此通知效力等同批註，將成為保險契約的一部分。</li>
            <li class="pb-2">若欲查詢保單借款處理進度或取消本次預約申請，請點選【查詢/取消預約資料】查詢。</li>
            <li class="pb-2">您的保險單、存摺、印章、網路交易帳號密碼應親自保管，請勿交予他人，本公司嚴禁業務同仁代保管客戶保險單、存摺、印章、網路交易帳號密碼等資料。</li>
            <li class="pb-2">若您對於本次變更申請有任何疑問,請撥打本公司 24 小時免付費電話 0809-000-550 洽詢。</li>
        </ul>

        <template v-slot:bottom>
            <div class="footer-shadow">
                <div class="flex w-full px-2 py-3 max-w-[768px] mx-auto">
                    <div class="flex-1 px-2">
                        <RouterLink class="block py-3 text-center rounded bg-[#CCF3FF] text-[#0093C1]"
                            :to="{ name: '' }">
                            查看申請進度
                        </RouterLink>
                    </div>
                    <div class="flex-1 px-2">
                        <RouterLink class="block py-3 text-center rounded bg-[#0093C1] text-white"
                            :to="{ name: 'cloudCounterHome' }">
                            回首頁
                        </RouterLink>
                    </div>
                </div>
            </div>
        </template>

    </Layout>

</template>

<style scoped>
.footer-shadow {
    box-shadow: 0px -4px 12px 0px #0C0E1F0A;
}
</style>